import { PropsWithChildren } from 'react'

import { Badge } from 'antd'

import { CertificationEntity } from '@eastcoal/api/auth/interface'

import { CERTIFICATION_DATE_STATUS } from '../../../utils/enum'
import { isValidCertificationDate } from '../../../utils/isValidDate'

type ValidDateRibbonProps = {
  data?: CertificationEntity
}

export const CertificationValidDateRibbon = ({
  data,
  children
}: PropsWithChildren<ValidDateRibbonProps>) => {
  const dateStatus = isValidCertificationDate(data)

  return (
    <Badge.Ribbon
      placement='end'
      color={
        dateStatus === CERTIFICATION_DATE_STATUS.EFFECTIVE ? 'blue' : 'orange'
      }
      text={
        dateStatus === CERTIFICATION_DATE_STATUS.EFFECTIVE
          ? '未过期'
          : dateStatus === CERTIFICATION_DATE_STATUS.OUTEFFECTIVE
            ? '已过期'
            : '未生效'
      }
    >
      {children}
    </Badge.Ribbon>
  )
}
